import { compose } from 'redux';
import { WithCMSSEO } from 'modules/shared-cms/hocs';
import {
    WithFetchDatasByParamsFromCMS,
    WithFetchDatasByParamsFromCMSInputProps,
} from 'modules/shared-cms-advanced/hocs';
import { readPageTitle } from 'modules/shared-cms/utils';
import { WithNotifyRessourceLoadedInputProps, WithNotifyRessourceLoaded } from '../../../shared/hocs';

import { QUERY } from './creator-query';
import { CreatorLoader } from './creator-loader';
import { CreatorProps } from '.';

const enhancer = compose<
    React.ComponentType<WithFetchDatasByParamsFromCMSInputProps & WithNotifyRessourceLoadedInputProps>
>(
    WithFetchDatasByParamsFromCMS<CreatorProps>(CreatorLoader, QUERY, 'queryCornerMarqueContents', [
        { name: 'cornerFilter', filter: "data/brandId/iv eq $brandId  and data/typeMarque/iv eq 'robes'" },
        { name: 'dressFilter', filter: 'data/brandId/iv eq $brandId' },
    ]),
    WithNotifyRessourceLoaded(readPageTitle),
    WithCMSSEO(),
);
export default enhancer;
